import React from "react";
import Common, { commonData, getRandomColor } from "./../../Common";
import Header from "./../../Header";
import { connect } from "react-redux";
import { Card, Col, Container, Row, Form } from "react-bootstrap";
import BoardListing from "../attributeset/BoardListing/BoardListing";
import Message from "../UI/Message";
import NewModal from "../UI/NewModal";
import action from "../../Actions";
import Loading from "../UI/Loading";
import BoardModal from "../UI/BoardModal";
import Button from "../UI/Button";

class Listing extends Common {
  constructor(props) {
    super(props);
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      redirect: false,
      loader: false,
      data: [],
      loading: false,
      commondata: "",
      noActiveContent: "",
      noDeactiveContent: "",
      renameBoard: {},
      toggledClearRows: false,
      isLoading: "data-loader",
      boards: [],
      deactiveboards: [],
      redirect: false,
      showModalEdit: false,
      userdetails: "",
      createBoard: {
        board: false,
        message: "",
        title: "",
        position: "bottom-end",
        bg: "",
      },
      tattleBoard: {
        error: {},
        board_name: "",
        attribute_set_type: 2,
        boardModal: false,
      },
    };
    this.boardmodal = React.createRef();
  }

  componentDidUpdate = (prevProps) => {
    if (this.props !== prevProps) {
      this.setState(
        (state) => {
          return {
            ...state,
            loginData: this.props.login,
            boards: this.props.boards.active_boards,
            deactiveboards: this.props.boards.inactive_boards,
            redirect: this.props.boards.redirect,
          };
        },
        () => {
          //when a new board is created this will check the redirect is true or not the it will redirect to list page
          if (this.state.redirect) {
            this.props.history.push({
              pathname: `/tattle/${this.props.boards.singleBoard.attribute_set_key}/list`,
              state: { data: this.props.boards.singleBoard },
            });
          }
        }
      );
    }
  };

  componentDidMount = async () => {
    try {
      this.props.checkSidebarLink("list");
      let userdetails = "";
      var title = this.props.title ? this.props.title : "";
      document.title = `Tattle | ${title}`;
      this.setState((state) => {
        return {
          ...state,
          boards: this.props.boards?.active_boards,
          loginData: this.props.login,
          deactiveboards: this.props?.boards?.inactive_boards,
          userdetails: userdetails,
          commondata: { ...this.getCommonData() },
        };
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  //board name edit
  editBoardNameHandler = (index, name, key) => {
    this.setState({
      ...this.state,
      showModalEdit: true,
      renameBoard: { ...this.state.renameBoard, name: name, key: key },
    });
  };

  // rename board
  nameOnChangeHandler = async (board) => {
    const { data } = this.state.userdetails;
    try {
      const response = await fetch(`${this.state.apiUrl}board/update`, {
        method: "post",
        body: JSON.stringify({
          app_token: this.state.commondata.app_token,
          user_uuid: this.state.commondata.user_uuid,
          attribute_set_name: board.name,
          attribute_set_key: board.set_key,
        }),
      });
      const rdata = await response.json();
      if (rdata.code === 200) {
        this.setState(
          (state) => {
            return {
              ...state,
              // createBoard: {
              //   ...state.createBoard,
              //   title: "Board",
              //   message: rdata.message,
              //   board: true,
              //   bg: "primary",
              // },
              showModalEdit: false,
            };
          },
          () => {
            this.props.getAllBoards(this.state.commondata.app_token);
          }
        );
      } else {
        this.setState((state) => {
          return {
            ...state,
            createBoard: {
              ...state.createBoard,
              title: "Board",
              message: rdata.message,
              board: true,
              bg: "danger",
            },
            showModalEdit: true,
          };
        });
      }
    } catch (eror) {
      console.log(eror.message);
    }
  };

  // common function for activate and deactivate the board
  //which is calling from active and deactive function
  boardStatusChange = async (status, key) => {
    try {
      const { data } = this.state.userdetails;
      const deactivateDetails = {
        app_token: this.state.commondata.app_token,
        user_uuid: this.state.commondata.user_uuid,
        attribute_set_key: key,
        attribute_set_status: status,
      };
      if (status === 2) {
        const response = await this.props.deleteBoard(deactivateDetails);
        if (response.code == 200) {
          this.setState((state) => {
            return {
              ...state,
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: response.message,
              //   title: response.status,
              //   position: "bottom-end",
              //   bg: "primary",
              // },
            };
          });
        } else {
          this.setState((state) => {
            return {
              ...state,
              createBoard: {
                ...state.createBoard,
                board: true,
                message: response.message,
                title: response.status,
                position: "bottom-end",
                bg: "danger",
              },
            };
          });
        }
      }
      if (status === 0) {
        const response = await this.props.boardDeactivate(deactivateDetails);
        console.log(response, 54647987946546);
        if (response.code == 200) {
          this.setState((state) => {
            return {
              ...state,
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: response.message,
              //   title: response.status,
              //   position: "bottom-end",
              //   bg: "primary",
              // },
            };
          });
        } else {
          this.setState((state) => {
            return {
              ...state,
              createBoard: {
                ...state.createBoard,
                board: true,
                message: response.message,
                title: response.status,
                position: "bottom-end",
                bg: "danger",
              },
            };
          });
        }
      }

      if (status === 1) {
        const response = await this.props.activeBoardHandler(deactivateDetails);
        if (response.code == 200) {
          this.setState((state) => {
            return {
              ...state,
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: response.message,
              //   title: response.status,
              //   position: "bottom-end",
              //   bg: "primary",
              // },
            };
          });
        } else {
          this.setState((state) => {
            return {
              ...state,
              createBoard: {
                ...state.createBoard,
                board: true,
                message: response.message,
                title: response.status,
                position: "bottom-end",
                bg: "danger",
              },
            };
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // this will deactivate the board
  deactivateBoard = async (index, key) => {
    const active_boards = [...this.state.boards];
    const remove_boards = active_boards.splice(index, 1);
    const newdeactiveboards = [...this.state.deactiveboards, ...remove_boards];
    this.boardStatusChange(0, key);
    this.setState((state) => {
      return {
        ...state,
        boards: active_boards,
        deactiveboards: newdeactiveboards,
      };
    });
  };

  deleteBoardHandler = (index, key) => {
    const activeBoard = [...this.state.boards];
    const deactiveBoards = [...this.state.deactiveboards];
    const deactiveindex = deactiveBoards.findIndex(
      (de) => de.attribute_set_key === key
    );
    const activeindex = activeBoard.findIndex(
      (de) => de.attribute_set_key === key
    );
    if (deactiveindex !== -1) {
      deactiveBoards.splice(deactiveindex, 1);
      this.setState(
        (state) => {
          return { ...state, deactiveboards: deactiveBoards };
        },
        () => this.boardStatusChange(2, key)
      );
    } else {
      activeBoard.splice(activeindex, 1);
      this.setState(
        (state) => {
          return { ...state, boards: activeBoard };
        },
        () => this.boardStatusChange(2, key)
      );
    }
  };

  //fetch all the active board list to the container
  getActiveBoardsList = () => {
    let active_boards = (
      <Col md={4} xs={12} sm={6} lg={4}>
        {!this.state.boards.length > 0 && <p>No Boards Found</p>}
      </Col>
    );

    if (this.state.boards?.length > 0) {
      active_boards = this.state.boards.map((board, index) => (
        <Col md={4} xs={12} sm={6} lg={4} key={index}>
          <BoardListing
            board_data={board}
            deactivate={() =>
              this.deactivateBoard(index, board.attribute_set_key)
            }
            deactive={true}
            deleteBoard={() =>
              this.deleteBoardHandler(index, board.attribute_set_key)
            }
            editName={() =>
              this.editBoardNameHandler(
                index,
                board.attribute_set_name,
                board.attribute_set_key
              )
            }
            setting={{
              set_key: board.attribute_set_key,
              name: board.attribute_set_name,
              attribute_set_type: board.attribute_set_type,
            }}
            isAdmin={+this.state.commondata.is_admin}
          />
        </Col>
      ));
    }

    return active_boards;
  };

  // this function will call to activate the board
  activateBoardHandler = (index, key) => {
    const deactiveboards = [...this.state.deactiveboards];
    const singleremove = deactiveboards.splice(index, 1);
    const activeBoards = [...this.state.boards, ...singleremove];
    this.boardStatusChange(1, key);
    this.setState((state) => {
      return { ...state, boards: activeBoards, deactiveboards: deactiveboards };
    });
  };

  // get all deactivate boad list
  getDeactiveBoardList = () => {
    let deactive_boards = (
      <Row>
        <Col lg={12} md={12}>
          {!this.state.loader && this.state.noDeactiveContent}
        </Col>
      </Row>
    );

    if (this.state.deactiveboards?.length > 0) {
      deactive_boards = this.state.deactiveboards.map((dboard, index) => (
        <Col md={4} xs={12} sm={6} lg={4} className="mb-4" key={index}>
          <BoardListing
            board_data={dboard}
            active_board={() =>
              this.activateBoardHandler(index, dboard.attribute_set_key)
            }
            editName={() =>
              this.editBoardNameHandler(
                index,
                dboard.attribute_set_name,
                dboard.attribute_set_key
              )
            }
            active={true}
            deactivate={true}
            deleteBoard={() =>
              this.deleteBoardHandler(index, dboard.attribute_set_key)
            }
            isAdmin={+this.state.commondata.is_admin}
            setting={{
              set_key: dboard.attribute_set_key,
              name: dboard.attribute_set_name,
              attribute_set_type: dboard.attribute_set_type,
            }}
          />
        </Col>
      ));
    }

    return deactive_boards;
  };

  // it will create new board
  addBoardHandler = async () => {
    this.setState({
      ...this.state,
      tattleBoard: {
        ...this.state.tattleBoard,
        boardModal: true,
      },
    });
  };

  onBoardCreateHandler = (ev) => {
    ev.preventDefault();

    const { board_name, attribute_set_type } = { ...this.state.tattleBoard };
    const error = { ...this.state.tattleBoard.error };
    if (board_name.trim().length === 0) {
      error["board_name"] = "Board name can't be blank";
      this.setState({
        ...this.state,
        tattleBoard: {
          ...this.state.tattleBoard,
          error: { ...this.state.tattleBoard.error, ...error },
        },
      });
      return;
    } else if (attribute_set_type.length === 0) {
      error["attribute_set_type"] = "Board type can't be blank";
      this.setState({
        ...this.state,
        tattleBoard: {
          ...this.state.tattleBoard,
          error: { ...this.state.tattleBoard.error, ...error },
        },
      });
      return;
    } else {
      error["board_type"] = "";

      error["board_name"] = "";
      this.setState({
        ...this.state,
        tattleBoard: {
          ...this.state.tattleBoard,
          error: error,
        },
      });
    }

    const { data } = this.state.userdetails;
    const boardDetails = {
      app_token: this.state.commondata.app_token,
      user_uuid: this.state.commondata.user_uuid,
      board_name: this.state.tattleBoard.board_name,
      attribute_set_type: +this.state.tattleBoard.attribute_set_type,
      color: getRandomColor(),
    };
    this.props.createSingleBoard(boardDetails);
  };

  onBoardHandlerChange = (ev) => {
    const { name, value } = ev.target;
    this.setState({
      ...this.state,
      tattleBoard: { ...this.state.tattleBoard, [name]: value, error: {} },
    });
  };
  hideBoardModal = () => {
    this.setState({
      ...this.state,
      tattleBoard: {
        ...this.state.tattleBoard,
        boardModal: false,
      },
    });
  };

  render() {
    return (
      <>
        <BoardModal
          refs={this.boardmodal}
          show={this.state.tattleBoard.boardModal}
          hideBoardModal={this.hideBoardModal}
        >
          {" "}
          <Form className="form" onSubmit={this.onBoardCreateHandler}>
            <div class="inputbox-group">
              <label class="col-12">Board name</label>
              <input
                placeholder="Board name"
                type="text"
                name="board_name"
                value={this.state.tattleBoard.board_name}
                onChange={this.onBoardHandlerChange}
                class="input-cls form-control"
                autocomplete="off"
              />
              <div className="error-feedback">
                {this.state.tattleBoard.error["board_name"]}
              </div>
            </div>
            <div class="inputbox-group mt-3">
              <label class="col-12">Board Type</label>
              <select
                placeholder="Board Type"
                name="attribute_set_type"
                value={this.state.tattleBoard.attribute_set_type}
                onChange={this.onBoardHandlerChange}
                className="form-control"
              >
                <option value="2">Support Ticket</option>
                <option value="3">Project Management</option>
                <option value="4">Todo</option>
                <option value="5">Crm</option>
                <option value="1">Advance</option>
              </select>
              <div className="error-feedback">
                {this.state.tattleBoard.error["attribute_set_type"]}
              </div>
            </div>

            <Button
              text={this.props.boards?.loadcreate ? "Submiting..." : "Submit"}
              type="submit"
              className="muBtn _blue sm mt-3"
              isDisabled={this.props.boards?.loadcreate}
            />
          </Form>
        </BoardModal>

        <div className="mainContent-panel-wrap" style={{ overflow: "auto" }}>
          {this.state.createBoard.board && (
            <Message board={this.state.createBoard} />
          )}
          <Header
            brecum_name={{ name: "", link: "" }}
            brecum_page={this.props.title}
          />
          {this.state.showModalEdit ? (
            <NewModal
              label="Board Name"
              renameBoard={this.state.renameBoard}
              nameOnChangeHandler={this.nameOnChangeHandler}
            />
          ) : (
            ""
          )}
          <Container fluid>
            <div className="page-content pt-3 new-content-main">
              <Card className="border-0 p-0">
                <Card.Body className="p-0">
                  <div className="p-3 ps-4 border-bottom">
                    <div className="title">Boards</div>
                  </div>
                  <div className="px-4 py-4">
                    <Row>
                      {this.getActiveBoardsList()}
                      {+this.state.commondata.is_admin === 1 && (
                        <Col
                          xs={12}
                          sm={6}
                          md={4}
                          lg={4}
                          onClick={this.addBoardHandler}
                        >
                          <div class="todo-input">
                            <div class="left-div six-color">
                              <span>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 7V0H7V7H0V9H7V16H9V9H16V7H9Z"
                                    fill="#909090"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                            <div class="right-div">Create Board</div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Card.Body>
              </Card>
              {this.state.deactiveboards.length > 0 &&
              Number(this.getCommonData().is_admin) ? (
                <Card className="border-0 p-0 mt-5">
                  <Card.Body className="p-0">
                    <div className="p-3 ps-4 border-bottom">
                      <div className="title">Deactivated Boards</div>
                    </div>
                    <div className="px-4 py-4">
                      <Row>
                        {this.props.boards?.loading && <Loading />}

                        {this.getDeactiveBoardList()}
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              ) : (
                ""
              )}
            </div>
          </Container>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    boards: state.allBoards,
    login: state.loginDetails.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllBoards: (inputs) => {
      dispatch(action.fetAllBoards(inputs));
    },
    createSingleBoard: async (inputs) => {
      dispatch(action.storesingleboard(inputs));
    },
    deleteBoard: (input) => {
      dispatch(action.deleteboard(input));
    },
    checkSidebarLink: (set_key) => {
      dispatch(action.checkLinkForSideMenu(set_key));
    },
    boardDeactivate: (inputs) => {
      return dispatch(action.boardDeactivate(inputs));
    },
    activeBoardHandler: (inputs) => {
      return dispatch(action.activeBoardHandler(inputs));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Listing);
